import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { useConfirm } from './ConfirmContext';

import { ReactComponent as Spinner } from './images/spinner2.svg';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const PaymentModal = ({setVisible}) => {
  return (
    <Modal isOpen={true}
           zIndex={101} >
      <div style={{zIndex: '101',
                   backgroundColor: 'white',
                   color: 'black',
                   position: 'absolute',
                   transform: 'translate(-50%, -50%)',
                   top: '50%',
                   left: '50%',
                   margin: '1px',
                   width: '600px',
                   boxSizing: 'border-box',
                   borderRadius: '5px',
                   display: 'flex',
                   justifyContent: 'center',
                   flexDirection: 'column',
                   padding: '40px',
                   gap: '20px',
                  }}>
        <div style={{
               display: 'flex',
               flexDirection: 'row',
               alignItems: 'center',
               justifyContent: 'space-between',
               width: '100%',
             }}>
          <span style={{fontSize: '22px',
                        fontWeight: 'bold',
                       }}>
            Your payment was submited successfully
          </span>
        </div>
      </div>
    </Modal>
  );
}

const PaymentForm = () => {
  const confirm = useConfirm();

  const stripe = useStripe();
  const elements = useElements();
  const [processing, setProcessing] = React.useState(false);
  const [user, setUser] = useState({});

  const [modalVisible, setModalVisible] = useState(false);

  const [token, setToken] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    setToken(params.get('token'));
    setUser({ name: '' });
  }, []);

  const create = async () => {
    setProcessing(true);
    const cardElement = elements.getElement(CardElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
      billing_details: {
        name: user.name
      },
    });

    if (error) {
      await confirm('Please enter a valid card', true);
      return;
    }

    let paymentMethodId = paymentMethod.id;

    fetch(process.env.REACT_APP_SERVER_URL + '/api/submit-payment', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ token, name: user.name, paymentMethodId})})
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          setProcessing(false);
          setModalVisible(true);
        }
      });
  }

  return (
    <div style={{display: 'flex',
                 flexDirection: 'column',
                 backgroundColor: 'white',
                 height: '100%',
                }}>

      {modalVisible && (
        <PaymentModal setVisible={setModalVisible} />
      )}

      <div style={{flex: 1,
                   display: 'flex',
                   alignItems: 'center',
                   justifyContent: 'space-around',
                   color: 'black',
                   padding: '80px',
                   gap: '50px',
                  }}>

        <form style={{width: '30%',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '20px',
                     }}
              onSubmit={(e) => {
                e.preventDefault();
                create();
              }}>
          <div style={{display: 'flex',
                       gap: '10px',
                       flexDirection: 'column',
                      }}>
            <span>Please enter the payment details</span>

            <div
              style={{ width: '100%',
                       padding: '15px',
                       boxSizing: 'border-box',
                       borderRadius: '5px',
                       border: '1px solid #d3d3d3',
                     }}>
              <div style={{
                     border: '1px solid #dfe3e8',
                     borderRadius: '4px',
                     padding: '12px',
                     background: '#fff',
                     marginBottom: '12px',
                   }}>
                <input
                  type="text"
                  placeholder="Cardholder name"
                  value={user.name}
                  onChange={(e) =>
                    setUser(prev => ({
                      ...prev,
                      name: e.target.value
                    }))
                  }
                  style={{
                    width: '100%',
                    border: 'none',
                    outline: 'none',
                    fontSize: '16px',
                    color: 'black',
                    background: 'transparent',
                  }}
                />
              </div>
              <div style={{
                     border: '1px solid #dfe3e8',
                     borderRadius: '4px',
                     padding: '12px',
                     background: '#fff',
                     marginBottom: '12px',
                   }}>
                <CardElement options={{
                               style: {
                                 base: {
                                   fontSize: '16px',
                                   color: 'black',
                                   '::placeholder': { color: 'gray' },
                                 }
                               }
                             }} />
              </div>
            </div>
          </div>

          <div style={{display: 'flex',
                       width: '100%',
                       justifyContent: 'center',
                      }}>
            <button style={{width: '100%',
                            padding: '15px',
                            backgroundColor: '#008fe9',
                            color: 'white',
                            border: 'none',
                            borderRadius: '5px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            fontFamily: 'inherit',
                           }}>
              {processing && (
                <Spinner style={{
                           width: '30px',
                           height: '30px',
                           animation: 'spin 1s linear infinite',
                         }} />
              )}
              {!processing && 'Submit'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const Payment = () => {
  return (
    <Elements stripe={stripePromise}>
      <PaymentForm/>
    </Elements>
  );
}
export default Payment;
